import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Container, Message } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "../styles/ErrorPage.less";

/**
 * Make it possible to use a relative or an absolute url as needed.
 */
const getLink = (url, text) => {
  // if url is absolute (e.g starts with http:// or https://), then let's use a generic anchor element.
  if (/^https?:\/\//.test(url)) {
    return <a href={url}>{text}</a>;
  }

  // Url is relative hence it's assumed a react browser Link's url.
  return <Link to={url}>{text}</Link>;
};

const ErrorPage = observer(({ title, helpText, continueUrl, continueText }) => (
  <div style={{ background: "white", paddingTop: "50px" }}>
    <Container>
      <Message size="huge" className="error-page">
        <Message.Header>{title}</Message.Header>
        <p>{helpText}</p>
        {continueUrl && <p>{getLink(continueUrl, continueText)}</p>}
      </Message>
    </Container>
  </div>
));

ErrorPage.propTypes = {
  title: PropTypes.string,
  helpText: PropTypes.string,
  continueUrl: PropTypes.string,
  continueText: PropTypes.string,
};

ErrorPage.defaultProps = {
  title: "Error",
  helpText: "An unexpected error has occurred. Please try again later.",
  continueText: "Continue",
};

export default ErrorPage;
